/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 * @enum {string}
 */
export var UpdateCellWithTransformRequestValueTransformTypeEnum;
(function (UpdateCellWithTransformRequestValueTransformTypeEnum) {
    UpdateCellWithTransformRequestValueTransformTypeEnum["Add"] = "ADD";
    UpdateCellWithTransformRequestValueTransformTypeEnum["Mul"] = "MUL";
    UpdateCellWithTransformRequestValueTransformTypeEnum["Set"] = "SET";
})(UpdateCellWithTransformRequestValueTransformTypeEnum || (UpdateCellWithTransformRequestValueTransformTypeEnum = {}));
export function UpdateCellWithTransformRequestFromJSON(json) {
    return UpdateCellWithTransformRequestFromJSONTyped(json, false);
}
export function UpdateCellWithTransformRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        value: json['value'],
        sourceTagIds: json['sourceTagIds'],
        tagIdTransform: json['tagIdTransform'],
        valueTransformType: json['valueTransformType'],
    };
}
export function UpdateCellWithTransformRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        value: value.value,
        sourceTagIds: value.sourceTagIds,
        tagIdTransform: value.tagIdTransform,
        valueTransformType: value.valueTransformType,
    };
}
